import React, { useEffect, useRef } from 'react';
import Portal from './Portal';

const Drawer = ({ show, children, height, onHide = () => {}, className, portal = false, direction = 'right' }) => {
  const id = useRef(undefined);
  if (!id.current) {
    id.current = `drawer-${Math.floor(Math.random() * 100000)}`;
  }

  const handleWindowKeydown = (e) => {
    if (e.key === 'Escape') {
      onHide();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleWindowKeydown);
    return () => window.removeEventListener('keydown', handleWindowKeydown);
  }, []);

  const PortalComponent = portal ? Portal : React.Fragment;
  const portalProps = portal ? { id: id.current } : {};

  return (
    <PortalComponent {...portalProps}>
      <div className={`comp-drawer ${show ? 'active' : ''} ${className || ''} direction-${direction}`}>
        <div className="backing" onClick={onHide} />
        <div className={`content`} style={{ height }}>
          {children}
        </div>
      </div>
    </PortalComponent>
  );
};

export default Drawer;
